import { useDataTableQuery } from "@/components/data-table/hooks/useDataTableQuery";
import Form from "@/components/Form";
import { List } from "@/components/list/List";
import SaveButton from "@/components/SaveButton";
import useQueryData from "@/hooks/useQueryData";
import { useUpdateContractorVisitsMutation } from "@/modules/projects/components/contractors-visits/hooks/useUpdateContractorVisitsMutation";
import { ContractorVisitsEditorDirectoryFormSchema } from "@/modules/projects/components/contractors-visits/schema";
import { ContractorVisitsEditorDirectoryFormType } from "@/modules/projects/components/contractors-visits/types";
import { convertFormToWriteProjectStorePeriodContractorVisit } from "@/modules/projects/components/contractors-visits/utils";
import { useSyncFormWithQueryData } from "@/hooks/useSyncFormWithQueryData";
import { SuccessFetchListResponse } from "@/services/api";
import { ReadContractorVisit } from "@/types/contractorVisit";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "@/modules/projects/hooks/useCheckIsProjectLocked";

const defaultValues = {};

const ContractorVisitsEditorDirectoryForm = () => {
  const { can_update } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked();
  const form = useForm<ContractorVisitsEditorDirectoryFormType>({
    resolver: zodResolver(ContractorVisitsEditorDirectoryFormSchema),
    defaultValues,
    disabled: !can_update || isProjectLocked,
  });

  const { query } =
    useDataTableQuery<SuccessFetchListResponse<ReadContractorVisit>>();

  const data = useQueryData(query);
  useSyncFormWithQueryData(data, form);

  const updateMutation = useUpdateContractorVisitsMutation();

  const handleSubmit: SubmitHandler<ContractorVisitsEditorDirectoryFormType> =
    useCallback(
      async (data) => {
        const payload = convertFormToWriteProjectStorePeriodContractorVisit(
          data,
          form,
        );
        return updateMutation.mutateAsync(payload);
      },
      [form, updateMutation],
    );

  return (
    <Form form={form} handleSubmit={handleSubmit} className="gap-1">
      <List.Content>
        <List.Status />
      </List.Content>
      <footer className="flex p-2 justify-end gap-6">
        <SaveButton disabled={!can_update || isProjectLocked} />
      </footer>
    </Form>
  );
};

export default ContractorVisitsEditorDirectoryForm;
